import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import { Checkbox, FormControlLabel, Switch, TableHead } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { cancelIconRed } from "../../../common/cancelIconRed";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";

const capitalizeWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const CameraHealthTabAutopatrol = ({
  healthCheckData,
}: {
  healthCheckData: any;
}) => {
  const titlesArray = [
    "Camera Health Monitoring On",
    "Sensitivity",
    "Health Metrics",
  ];

  const { healthCheckMetricsData } = useSiteAboutStore();

  return (
    <>
      <TableContainer component={Paper} sx={{ width: "screen" }}>
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          {healthCheckData.deployment === 0 ? (
            <TableHead>
              <TableRow>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  Camera Health Monitoring On
                </TableCell>
              </TableRow>
              <TableBody>
                <TableRow>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {cancelIconRed}
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableHead>
          ) : (
            <>
              <>
                <TableHeadComponent titlesArray={titlesArray} />
                <TableBody>
                  <TableRow>
                    <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                      {healthCheckData.deployment === 3
                        ? checkedCircleIcon
                        : cancelIconRed}
                    </TableCell>
                    <TableCell>
                      {capitalizeWords(healthCheckData.sensitivity_level)}
                    </TableCell>
                    {healthCheckData.deployment !== 0 && (
                      <TableCell>
                        <FormGroup>
                          <div className="flex">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    healthCheckMetricsData.scene_change_check
                                      .enabled &&
                                    healthCheckMetricsData.motion_status_check
                                      .enabled &&
                                    healthCheckMetricsData.recording_check
                                      .enabled &&
                                    healthCheckMetricsData.stream_quality_check
                                      .enabled
                                  }
                                  disabled={true}
                                  name="all_metrics"
                                />
                              }
                              label="All Metrics"
                            />
                            <FormControlLabel
                              sx={{ marginLeft: "20px" }}
                              control={
                                <Checkbox
                                  checked={
                                    healthCheckMetricsData.scene_change_check
                                      .enabled
                                  }
                                  disabled={true}
                                  name="scene_change_check"
                                />
                              }
                              label="Scene Change"
                            />
                            <FormControlLabel
                              sx={{ marginLeft: "20px" }}
                              control={
                                <Checkbox
                                  checked={
                                    healthCheckMetricsData.stream_quality_check
                                      .enabled
                                  }
                                  disabled={true}
                                  name="stream_quality_check"
                                />
                              }
                              label="Stream Quality"
                            />
                          </div>
                        </FormGroup>
                      </TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </>
            </>
          )}
        </Table>
      </TableContainer>
    </>
  );
};
